import * as _ from 'lodash';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

class WageCalculationWageType {
    constructor(type, src) {
        this.Kind = type;
        if (src) {
            this.WageTypeId = src.WageTypeId;
        }
    }

    getType() {
        return this.Kind;
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.WageType = ctx.getWageType(this.WageTypeId);
    }

    isEmpty() {
        return !this.WageType;
    }

    toJSON() {
        if (!this.WageType) return;

        return {
            Kind: this.Kind,
            WageTypeId: this.WageType.Id
        };
    }
}

class WageTypeCollection {
    constructor(list) {
        this.all = [];
        list = list || [];

        const createWCWT = kind => {
            const existing = _.find(list, x => x.Kind === kind);
            const wcwt = new WageCalculationWageType(kind, existing);
            this.all.push(wcwt);
            return wcwt;
        };

        this.Ordinary = [createWCWT(0), createWCWT(1), createWCWT(2)];
        this.Substitute = [createWCWT(3), createWCWT(4), createWCWT(5)];
        this.Serving = [createWCWT(6), createWCWT(7), createWCWT(8)];
        this.Travel = createWCWT(9);
    }

    toJSON() {
        return _.filter(this.all, x => !x.isEmpty());
    }

    nonEmpty() {
        return _.filter(this.all, x => !x.isEmpty());
    }
}

export class WageCalculation extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);
        }
        this.WageTypes = new WageTypeCollection(this.WageTypes);
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        _.each(this.WageTypes.all, x => x.resolve(ctx));
    }
}
